<div class="school-teacher-filter" [class]="{ 'school-teacher-filter-padded': padding() }">
  <div class="school-teacher-filter-wrapper">
    @if (showDistrict()) {
      <div id="districtFilter">
        <label>District</label>
        <ng-select
          [items]="districts()"
          bindLabel="name"
          [(ngModel)]="selectedDistrict"
          [clearable]="false"
          (change)="changeDistrict()"
          [style.min-width]="'128px'"
        ></ng-select>
      </div>
    }
    @if (showSchool()) {
      <div id="schoolFilter">
        <label for="school-filter">School</label>
        @let allDistrictsSelected = this.selectedDistrict()?.districtID === 0;
        <ng-select
          labelForId="school-filter"
          [items]="allDistrictsSelected ? [] : schools()"
          bindLabel="name"
          [(ngModel)]="selectedSchool"
          [clearable]="false"
          (change)="changeSchool()"
          [style.min-width]="'128px'"
          [disabled]="allDistrictsSelected"
        ></ng-select>
      </div>
    }
    @if (showTeacher()) {
      <div id="teacherFilter">
        <label for="teacher-filter">Teacher</label>
        <ng-select
          labelForId="teacher-filter"
          [(ngModel)]="selectedTeacher"
          [clearable]="false"
          (change)="updateFilter()"
          [style.min-width]="'128px'"
        >
          @for (teacher of teachers() ; track teacher.userID) {
            <ng-option [value]="teacher">{{teacher.firstName}} {{teacher.lastName}}</ng-option>
          }
        </ng-select>
      </div>
    }
    @if (error()) {
      <div class="school-teacher-filter-error-label vertical_text_container">
        {{ error() }}
      </div>
    }
  </div>
</div>
